import React, { useState, useMemo, useCallback, useEffect } from "react"
import useWindowDimensions from "@hooks/useWindowDimensions"
import burgerIcon from "@images/blog/black-ic-burger.svg"
import closeIcon from "@images/blog/black-ic-cancel.svg"
import { preventScrolling } from "../../../../../../utils/prevent-scrolling"
import { LinksContainer, NavButtons } from "../../components/Header/components"
import { StyledLinksWrapper } from "../../components/Header/components/BurgerMenu/styled"

const useBurgerConfiguration = ({ showLinks, setShowLinks, path, handleClick }) => {
  const [isClosing, setIsClosing] = useState(true)
  const [isBurgerProcessed, setIsBurgerProcessed] = useState(true)
  const { isDesktop, isTablet, isMobile } = useWindowDimensions()

  useEffect(() => 
    () => {
      document.removeEventListener("wheel", preventScrolling, {
        passive: false,
      })
    }, [showLinks])

  const generateLinksContainer = useMemo(() => {
    const mainContent = (
      <>
        <LinksContainer setShowLinks={setShowLinks} path={path} />
        {isMobile && <NavButtons />}
      </>
    )
    if (!isDesktop) {
      return (
        <StyledLinksWrapper isMobile={isMobile}>
          {mainContent}
        </StyledLinksWrapper>
      )
    }
    return mainContent
  }, [isDesktop, isMobile, window.innerHeight])

  const menuIcon = useMemo(
    () => (showLinks && !isClosing ? closeIcon : burgerIcon),
    [showLinks, burgerIcon, isClosing]
  )

  const handleMenuToggle = useCallback((e) => {
      if (!isBurgerProcessed) return

      setIsBurgerProcessed(false)
      setTimeout(() => setIsBurgerProcessed(true), 1000)

      if (showLinks) {
        document.removeEventListener("wheel", preventScrolling, {
          passive: false,
        })
        setIsClosing(true)
      } else {
        document.addEventListener("wheel", preventScrolling, {
          passive: false,
        })
        setIsClosing(false)
      }
      handleClick(e)
    },
    [
      isBurgerProcessed,
      setIsBurgerProcessed,
      showLinks,
      setIsClosing,
      handleClick,
    ]
  )

  const handleFilterToggle = useCallback(() => {
    setTimeout(() => {
      // will be run after the rest of the code
      setOpenMobileFilters(false)
    }, 1)
  }, [setIsBurgerProcessed])

  return {
    isClosing,
    menuIcon,
    isTablet,
    generateLinksContainer,
    handleMenuToggle,
    handleFilterToggle,
  }
}

export default useBurgerConfiguration
